(function () {
  function norm(s) {
    return String(s == null ? '' : s)
      .trim()
      .toLowerCase();
  }

  function bindRoot(root) {
    var defaultTab = norm(root.getAttribute('data-default-tab')) || 'store';
    var tabs = root.querySelectorAll('[data-recruit-tab]');

    function activate(tab) {
      tab = norm(tab) || defaultTab;
      var items = root.querySelectorAll('.recruit-jobs__item');

      root.setAttribute('data-active-tab', tab);
      tabs.forEach(function (btn) {
        var btnTab = norm(btn.getAttribute('data-recruit-tab'));
        var isActive = btnTab === tab;
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      items.forEach(function (el) {
        var cat = norm(el.getAttribute('data-recruit-category'));
        if (cat === tab) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
          el.removeAttribute('open');
        }
      });

      var countForTab = 0;
      items.forEach(function (el) {
        if (norm(el.getAttribute('data-recruit-category')) === tab) countForTab += 1;
      });

      var tabEmpty = root.querySelector('[data-recruit-tab-empty]');
      var stack = root.querySelector('.recruit-jobs__stack');
      if (tabEmpty) {
        if (countForTab === 0) {
          tabEmpty.removeAttribute('hidden');
        } else {
          tabEmpty.setAttribute('hidden', '');
        }
      }
      if (stack) {
        if (countForTab === 0) stack.classList.add('recruit-jobs__stack--tab-empty');
        else stack.classList.remove('recruit-jobs__stack--tab-empty');
      }
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-recruit-tab'));
      });
    });

    activate(defaultTab);

    function refresh() {
      activate(root.getAttribute('data-active-tab') || defaultTab);
    }

    document.addEventListener('shopify:section:load', refresh);
    window.addEventListener('load', refresh);
    requestAnimationFrame(refresh);
  }

  function init() {
    document.querySelectorAll('.js-recruit-jobs').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
